import { useCallback } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { useTrackWorkflow, WorkflowSteps } from '../../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../../tracking/tracking-constants';

const useAddFunds = ({ onAddFunds, onSaveDefaultFundingAmount, onSuccess, currencyCode }) => {
  const [errors, setErrors] = useAsyncSafeState();
  const trackAddFunds = useTrackWorkflow(Workflows.ADD_FUNDS_FLOW);
  const purchaseFunds = useCallback(
    async (_useAsDefault, _fundAmount) => {
      setErrors(null);
      const amount = {
        value: Number(_fundAmount),
        code: currencyCode,
      };

      try {
        if (_useAsDefault) {
          await onSaveDefaultFundingAmount(amount);
        }
        await onAddFunds(amount);
        trackAddFunds(WorkflowSteps.COMPLETE, {
          amount: amount.value,
          currency: amount.code,
        });
        onSuccess(amount);
      } catch (e) {
        setErrors(e?.response?.data?.Errors ?? [{}]);
        trackAddFunds(WorkflowSteps.ERROR, {
          error: e,
          amount: amount.value,
          currency: amount.code,
        });
      }
    },
    [setErrors, currencyCode, onAddFunds, trackAddFunds, onSuccess, onSaveDefaultFundingAmount],
  );

  return {
    errors,
    purchaseFunds,
  };
};

export default useAddFunds;
